import React from 'react';

import { type BlogMeta, WhatsNewArticle } from '@af/design-system-docs-ui';

import Content from './_assets/content.mdx';
import header from './_assets/header.png';

export const meta: BlogMeta = {
	title: 'Typography and iconography updates',
	author: 'Written by the Design System Team',
	description:
		'Discover the next big changes in our design language: bold new fonts and a beautiful intuitive iconography system.',
	image: header,
	publishDate: new Date(2025, 2, 18),
	readTime: '5 min read',
	type: 'Release roundup',
	href: '/whats-new/typography-and-iconography-updates',
};

export default () => {
	return <WhatsNewArticle meta={meta} content={<Content />} />;
};
